import { render, staticRenderFns } from "./PvVisArticleCard.vue?vue&type=template&id=60a747e4&scoped=true&"
import script from "./PvVisArticleCard.vue?vue&type=script&lang=js&"
export * from "./PvVisArticleCard.vue?vue&type=script&lang=js&"
import style0 from "./PvVisArticleCard.vue?vue&type=style&index=0&id=60a747e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a747e4",
  null
  
)

export default component.exports